import styled from 'styled-components'

export const Footer = styled.footer`
  width: 100%;
  height: 90px;
  padding-top: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-top: 1px solid black;
  margin-top: 4rem;
  display: flex;
  align-items: flex-start;
`

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const Text = styled.p`
  ${(props) => props.theme.textStyles.text}
  margin: 0;
`

export const Separator = styled.span`
  ${(props) => props.theme.textStyles.text}
  margin: 0;
`

export const CookieButton = styled.button`
  background: none;
  border: none;
  ${(props) => props.theme.textStyles.text}
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  
  &:hover {
    opacity: 0.7;
  }
`

export const CookieLink = styled.a`
  ${(props) => props.theme.textStyles.text}
  text-decoration: none;
  color: inherit;
  margin: 0;
  
  &:hover {
    opacity: 0.7;
  }
`
